// QR Kiosk v2 — KV2-7 skeletons (bug #13 convention: 1:1 mirrors, SkeletonBlock only,
// no entrance animation). TasksListSkeleton mirrors the scope line + one group card of
// rows; TaskDetailSkeleton mirrors the header card (header + meta grid + instructions).
import React from "react";
import { SkeletonBlock } from "../shared/SkeletonBlocks";

export function TasksListSkeleton() {
  return (
    <>
      <div style={{ padding: "4px 16px 0" }}>
        <SkeletonBlock w={180} h={9} />
      </div>
      <div style={{ padding: "14px 18px 6px" }}>
        <SkeletonBlock w={90} h={9} />
      </div>
      <div
        style={{
          margin: "0 14px",
          border: "1px solid var(--border)",
          borderRadius: 12,
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        {[0, 1, 2].map((i) => (
          <div key={i} style={{ padding: "12px 14px", borderTop: i === 0 ? "none" : "1px solid var(--border-soft)" }}>
            <SkeletonBlock w={100} h={10} />
            <SkeletonBlock w="72%" h={13} style={{ marginTop: 6 }} />
            <SkeletonBlock w={140} h={9} style={{ marginTop: 6 }} />
          </div>
        ))}
      </div>
    </>
  );
}

export function TaskDetailSkeleton() {
  return (
    <div
      style={{
        margin: "14px 14px 0",
        background: "var(--card)",
        border: "1px solid var(--border)",
        borderRadius: 12,
        boxShadow: "var(--shadow)",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {/* header */}
      <div style={{ padding: "14px 16px 12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <SkeletonBlock w={100} h={11} />
          <span style={{ flex: 1 }} />
          <SkeletonBlock w={72} h={22} r={999} />
        </div>
        <SkeletonBlock w="82%" h={16} style={{ marginTop: 9 }} />
      </div>

      {/* meta grid — 4 cells */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: 14,
          padding: "2px 16px 6px",
          borderTop: "1px solid var(--border-soft)",
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <div key={i} style={{ padding: "9px 0" }}>
            <SkeletonBlock w={48} h={8} />
            <SkeletonBlock w="70%" h={12} style={{ marginTop: 4 }} />
          </div>
        ))}
      </div>

      {/* instructions */}
      <div style={{ padding: "10px 16px 14px", borderTop: "1px solid var(--border-soft)" }}>
        <SkeletonBlock w={100} h={8} />
        <SkeletonBlock w="100%" h={11} style={{ marginTop: 7 }} />
        <SkeletonBlock w="88%" h={11} style={{ marginTop: 5 }} />
      </div>
    </div>
  );
}
